import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { SettingsPermissions } from '@campus/dal';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PermissionService } from '@campus/shared';

@Injectable({ providedIn: 'root' })
export class RedirectV2Guard implements CanActivate, CanActivateChild {
  private router = inject(Router);
  private permissionService: PermissionService = inject(PermissionService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.decide(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.decide(route, state);
  }

  private decide(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const skip = route.data?.['redirectV2Skip'] === true;
    if (skip || state.url.startsWith('/v2/')) return of(true);

    const explicitTarget = route.data?.['redirectV2To'] as string | undefined;

    return this.permissionService.hasPermission$(SettingsPermissions.APP_SHELL_V2).pipe(
      take(1),
      map((hasPermission) => {
        if (!hasPermission) return true;

        const target = explicitTarget ?? this.defaultTargetForUrl(state.url);
        return this.router.createUrlTree([target], {
          queryParams: route.queryParams,
          fragment: route.fragment,
        });
      })
    );
  }

  private defaultTargetForUrl(url: string): string {
    const clean = url.split('?')[0].replace(/^\/+/, '');
    return `/v2/${clean}`;
  }
}
